<template>
  <div class="my_footer">
        <div class="layout">
            <div class="footer_section_left">
                <p><span>南校区：河南省焦作市世纪路2001号</span>邮编：454003</p>
                <p><span>北校区：河南省焦作市解放中路142号</span>邮编：454000</p>
                <p><span>西校区：河南省焦作市建设西路55号</span>邮编：454001</p>
            </div>
            <div class="footer_section_center">
                <p>版权所有 河南理工大学</p>
                <p>工信部备案豫ICP备05002483号</p>
                <p>公安机关备案41081102000100号</p>
            </div>
            <img src="@/assets/images/logo_footer.png" class="my_footer_logo" />
        </div>
    </div>
</template>

<script>
export default {
  name: ""
};
</script>
<style scoped>
.my_footer{
    height: 150px;
    background: #2c324e;
    font-size: 13px;
}
.footer_section_left{
    margin-right: 200px;
}
.footer_section_left, .footer_section_center{
    color: #d5d6dc;
    float: left;
    margin-top: 35px;
}
.footer_section_left p, .footer_section_center p{
    margin-bottom: 15px;
}
.footer_section_left p span{
    width: 230px;
    display: block;
    float: left;
}

.my_footer_logo{
    float: right;
    margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/PC/footer.vue